import React from "react"
import GenericContactListing from "../common/listing/generic-listing/GenericContactListing"
import { ObjectType } from "../state/listing/generic-listing/index"

interface OwnProps {
    contactId: string
}

const AccountStatementListByContact = (props : OwnProps) => {
    const noResultElement = <div className="ui-module p-4 mb-0"></div>

    return (
        <>
            <GenericContactListing
                objectType={ObjectType.ACCOUNT_STATEMENTS}
                contactId={props.contactId}
                noResultElement={noResultElement}
            />
        </>
    )
}
export default AccountStatementListByContact


// WEBPACK FOOTER //
// ./src/customer/AccountStatementList.tsx